import React, { createContext, useState, useEffect, useContext } from 'react';
import * as API from '../lib/api';

const AuthContext = createContext(null);

// Lê a sessão salva já na primeira renderização: sem isso, abrir ou atualizar uma página protegida
// (favorito, app instalado, F5) mandava a pessoa para o login mesmo com a sessão válida.
const lerSessaoSalva = () => {
  try {
    const token = localStorage.getItem('inn_token');
    const cached = localStorage.getItem('inn_user');
    return token && cached ? JSON.parse(cached) : null;
  } catch { return null; }
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(lerSessaoSalva);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('inn_token');
    const cached = localStorage.getItem('inn_user');
    if (token && cached) {
      try { setUser(JSON.parse(cached)); } catch { /* noop */ }
      // refresh in background
      API.me().then((u) => {
        setUser(u);
        localStorage.setItem('inn_user', JSON.stringify(u));
      }).catch((err) => {
        // Só encerra a sessão se o servidor disser que ela é inválida; queda ou lentidão não deslogam.
        if (err?.response?.status === 401) {
          localStorage.removeItem('inn_token');
          localStorage.removeItem('inn_user');
          setUser(null);
        }
      }).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const aoExpirar = () => setUser(null);
    window.addEventListener('inn:sessao-expirada', aoExpirar);
    return () => window.removeEventListener('inn:sessao-expirada', aoExpirar);
  }, []);

  const persist = (token, u) => {
    localStorage.setItem('inn_token', token);
    localStorage.setItem('inn_user', JSON.stringify(u));
    setUser(u);
  };

  const login = async (email, password) => {
    const { access_token, user: u } = await API.login({ email, password });
    persist(access_token, u);
    return u;
  };

  const loginWithGoogle = async (credential) => {
    const { access_token, user: u } = await API.googleLogin(credential);
    persist(access_token, u);
    return u;
  };

  const register = async (payload) => {
    const { access_token, user: u } = await API.register(payload);
    persist(access_token, u);
    return u;
  };

  const logout = () => {
    localStorage.removeItem('inn_token');
    localStorage.removeItem('inn_user');
    setUser(null);
  };

  const refreshUser = async () => {
    const u = await API.me();
    setUser(u);
    localStorage.setItem('inn_user', JSON.stringify(u));
    return u;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, loginWithGoogle, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
